import React, {
    useState,
    Suspense,
    lazy,
    useEffect
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
    DragDropContext,
    Droppable,
    Draggable
} from 'react-beautiful-dnd';
import {
    createStyles,
    getStylesRef,
    ActionIcon,
    Button,
    Collapse,
    Select,
    Stack,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Card,
    Paper,
    Avatar,
    Group,
    TypographyStylesProvider,
    Text,
    UnstyledButton,
    UnstyledButtonProps,
    Title,
    Modal,
    rem,
    Divider,
    ScrollArea
} from '@mantine/core';
import {
    useDisclosure,
    useListState,
    useViewportSize
} from '@mantine/hooks';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import {
  IconBell,
  IconSettings,
  IconUsers,
  IconFileSettings,
  IconUserPlus,
  IconGavel,
  IconBuildingBank,
  IconRepeat,
  IconReceiptRefund,
  IconReceipt,
  IconReceiptTax,
  IconReport,
  IconCashBanknote,
  IconBook,
  IconCalendar,
  IconMessage,
  IconTextRecognition,
  IconPlus,
  IconChevronDown,
  IconPlaylistAdd,
  IconPencil,
  IconX,
  IconDeviceFloppy,
  IconCheck,
  IconTrash,
  IconGripVertical
} from '@tabler/icons';


import CarCardDetsHighlightsMgmtCE from '../components/CarCardDetsHighlightsMgmtCE';
import ConfirmationCardBase from  '../components/ConfirmationCardBase';
import { FooterSimple } from '../components/FooterSimple';

import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
//remove the auctionItemMgmtSlice imports
import {
    fieldInfoUpdated,
    selectSectionData,
    obj_fmts,
    arrayAddition
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    listItemInput: {
        maxWidth: '200px'
    },
    listItemBtn: {
        border: 'grey solid 1px',
        padding: '8px'
    },
    //added from drag and drop example
    item: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: theme.radius.md,
        border: `${rem(1)} solid ${
          theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
        padding: `${theme.spacing.sm} ${theme.spacing.xl}`,
        paddingLeft: `calc(${theme.spacing.xl} - ${theme.spacing.md})`, // to offset drag handle
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.white,
        marginBottom: theme.spacing.sm,
    },    
    itemDragging: {
        boxShadow: theme.shadows.sm,
    },
    symbol: {
        fontSize: rem(30),
        fontWeight: 700,
        width: rem(60),
    },
    dragHandle: {
        ...theme.fn.focusStyles(),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: theme.colorScheme === 'dark' ? theme.colors.dark[1] : theme.colors.gray[6],
        paddingLeft: theme.spacing.md,
        paddingRight: theme.spacing.md,
    },
    draggableLIstItem: {
        minWidth: '100%'
    },
    modeEvtBtn: {
        zIndex: -5
    },
    
}));


//needed: pass params to fill out the areas of the alert item
//export function AlertItem {
const CarCardDetsHighlightsMgmt = () => {
    const { classes, cx } = useStyles();
    const dispatch = useDispatch();
    const [opened, { toggle }] = useDisclosure(false);
    
    /*const [editList, { toggle}] = useDisclosure(false);
    const [modalOpened, { toggle }] = useDisclosure(false);*/
    const [overlayOpened, setOverlayOpened] = useState(false);
    const [selectedIdx, setSelectedIdx] = useState('na');
    const { height, width } = useViewportSize();
    const item_name = 'highlights_2_6';
    const component_md = {
        par: 'auctions',
        child: 'carCreatorData',//should be mode
        section: 'highlightsSection_6'
    };
    
    const rdux_map = {
        highlights_2_6: useSelector(selectSectionData(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'highlights_2_6'
            }
        )),
    };
    console.log(`rdux map length ${rdux_map['highlights_2_6'].length}`);
    
    //of_note:follow the same format from cardA
    //using as reference right now

   /*
    * FUNCTION SECTION
    * */
    //descript:open edit and pass index DragNDropEx
    const editList = (id, idx, curr_idx) => {
        console.log(`edit mode: ${idx} which is currently @ ${curr_idx}`);
        setSelectedIdx(id);
        setOverlayOpened(true);

    };
    //descript:show overlay with confirmation for delete
    const delListItem = (id, idx, curr_idx) => {
        //e.stopPropagation();
        console.log(`delete mode: ${idx} which is currently @ ${curr_idx}`);

    };

    //descript: save the new order of array items
    const saveListUpdate =() => {
        console.log('Save the current state of this list');
    }

    //descript: save the new order of array items
    const createNewList =() => {
        console.log('creating a new highlight list');
        let n_highlight_list = {...obj_fmts[component_md['par']][component_md['child']][component_md['section']].highlight_fmt_6};
        
        n_highlight_list['id_0'] = nanoid();
        //need to better handle the index
        let curr_l = rdux_map['highlights_2_6'].length;
        n_highlight_list['title_0'] = "Title Not Yet Set";
        n_highlight_list['idx_1'] = curr_l;
        n_highlight_list['curr_idx_1'] = curr_l;
        //item name format method may be helpful
        dispatch(arrayAddition(
            {
                itemVal: n_highlight_list,
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: 'highlights_2_6'
            }
        ));
        
        
        //add for main item
        //highlights_2_6
        //add highlights list item to highlights list
        //highlights_2_6=${n_highlight_list['id_0']}:items_2_6

        //del,get highlights list item to highlights list
        //highlights_2_6=${n_highlight_list['id_0']}:items_2_6=${bullet_pnt['id_0']}
        
        
        setSelectedIdx(n_highlight_list['id_0']);
        setOverlayOpened(true);
        //tie-in the creation and editing card
        //new part to the component md
        //open the 'CE' component
    }
    
    
    
    //of_note:using for testing
    //const [list_state, handlers] = useListState(rdux_map['highlights_2_6']);
    const [list_state, handlers] = useListState(rdux_map['highlights_2_6']);
    const [lState, setLState] = useState(rdux_map['highlights_2_6']);
    //const [list_state, handlers] = useListState(rdux_map['highlights_2_6']);
    
    //const [list_state, setListState] = useState(rdux_map['highlights_2_6']);
    //console.log(`value of list_state: ${rdux_map['highlights_2_6'][0]['title_0']}`);
    
    //make this into its own component

    //let draggable_highlights  = list_state.map((item, index) => {
    let draggable_highlights  = rdux_map['highlights_2_6'].map((item, index) => {
        return(
            <Draggable key={String(item.id_0)} index={index} draggableId={String(item.id_0)}>
                {(provided, snapshot) => (
                    <Card
                        maw={800}
                        mx="auto"
                        radius="md"
                        className={cx(classes.item, { [classes.itemDragging]: snapshot.isDragging })}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                    >
                        <Stack mx="auto" className={classes.draggableLIstItem}>
                            <Group position="apart">
                                <Button
                                    color="red"
                                    curridx={index}
                                    idx={item.idx_1}
                                    onClick={(e) => delListItem(item.id_0, item.idx_1, index)}
                                >
                                    <IconTrash size={18} color="white"/>
                                </Button>
                                <Button
                                    curridx={index}
                                    idx={item.idx_1}
                                    onClick={(e) => editList(item.id_0, item.idx_1, index)}
                                >
                                    <IconPencil size={18} color="white"/>
                                </Button>
                            </Group>
                            <Text ta="center">
                                {item.title_0}
                            </Text>
                            <div {...provided.dragHandleProps} className={classes.dragHandle}>
                                <IconGripVertical size="1.35rem" stroke={1.5} />
                            </div>
                        </Stack>
                    </Card>
                  )}
                </Draggable>
        );
        }
    );
    console.log(lState)
    
    //redux map and draw the bullet points
    let listViewCtx = (rdux_map['highlights_2_6'].length > 0) ? draggable_highlights : <Text ta="center">No Highlight Lists Yet</Text>;
    return (
        <>
                {/*<Card shadow="sm" padding="lg" radius="md" withBorder>*/}
            <Button
                fullWidth={true}
                leftIcon={<IconDeviceFloppy size={20}/>}
                color="blue"
                onClick={() => {saveListUpdate()}}
            >
                Save
            </Button>
            <br/>
            <Button 
                fullWidth={true}
                leftIcon={<IconPlaylistAdd size={20}/>}
                color="green"
                onClick={() => {createNewList()}}
            >
                New List
            </Button>
            <Divider 
                my="md"
            />
            {/*This needs to be a scroll area */}
            <ScrollArea 
                h={height * 0.85}
                type="never"
            >
                <br/>
                <DragDropContext
                    onDragEnd={({ destination, source }) =>
                        handlers.reorder({ from: source.index, to: destination?.index || 0 })
                    }
                >
                  <Droppable droppableId="dnd-list" direction="vertical">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {listViewCtx}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
            </ScrollArea >
            <br/>
            <Modal
                title="Editing 'Title Goes Here'"
                fullScreen={true}
                opened={overlayOpened}
                onClose={() => setOverlayOpened(false)}
            >
                {/*index should be set offo of a local state value*/}
                <CarCardDetsHighlightsMgmtCE highlight_id={selectedIdx}/>
                
                {/*confirmation card is an overlay ontop the CE view
                    
                    <ConfirmationCardBase message="confirm this is working"/>*/}
            </Modal>
            
        </>
    );
    
}
export default CarCardDetsHighlightsMgmt
